import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    constructor(private http: HttpClient, private api: GlobalService) {}

    getHomePageList(type) {
        const query = 'devices/homepage?type=';
        return this.http.get(this.api.endpoint + query + type, {
            headers: this.api.headers
        });
    }

    getDeviceList(
        offset = 1,
        // getBy,
        brandName,
        type = 'phone',
        minValue = 100,
        maxValue = 3000,
        sortDatePrice = 'new',
    ) {
        let query;
        // if (getBy === 'deviceType') {
        // clicked from menu
        switch (brandName) {
            case 'all':
                brandName = '';
                break;
            case 'newArrival':
            case 'bestSale':
            case 'hotPromotion':
            case 'default':
            case 'secondHand':
                brandName = `&label=${brandName}`;
                break;

            default:
                brandName = `&brand=${brandName}`;
                break;
        }
        // brandName === 'all' ? (brandName = '') : (brandName = `&brand=${brandName}`);
        // brandName === 'newArrival' ||
        // brandName === 'bestSale' ||
        // brandName === 'hotPromotion' ||
        // brandName === 'default'
        //     ? (brandName = `&label=${brandName}`)
        //     : '';
        query = `devices?limit=28&offset=${offset}&deviceType=${type}&priceRange=${minValue},${maxValue}&sortDatePrice=${sortDatePrice}${brandName}`;
        // } else {
        //     // clicked from sidebar
        //     query = `devices?limit=28&offset=${offset}&${getBy}=${type}&priceRange=${minValue},${maxValue}&date=${date}&price=${price}`;
        // }
        return this.http.get(this.api.endpoint + query, {
            headers: this.api.headers
        });
    }

    getDeviceDetail(url) {
        const query = `devices/${url}`;
        return this.http.get(this.api.endpoint + query, {
            headers: this.api.headers
        });
    }

    getRelated(brand, deviceType) {
        const query = `devices?limit=7&brand=${brand}&deviceType=${deviceType}`;
        return this.http.get(this.api.endpoint + query, {
            headers: this.api.headers
        });
    }
}
